<template>
	<div
			v-if="shouldShowSection('prize_creation') && !(shouldShowSection('basic') || shouldShowSection('advanced'))">

		<ui-box>
			<h5>Prizes</h5>
			<span class="grey--text text--darken-1 text-body-2">
			</span>

			<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

			<v-container class="pa-0 pb-r5">
				<v-row>
					<v-col>
						<bw-table aria-label="data-table" :headers="prizesHeaders"
											:items="displayAllPrizes"
											:showSearch="false"
											:key="prizesTableKey">
							<template v-slot:item.name="{ item: prize }">
								<div
										class="font-weight-bold text-subtitle-2 primary--text text--darken-4"
										style="flex-wrap: nowrap !important;"
								>
									{{ prize.name }}
								</div>
							</template>
							<template v-slot:item.actions="{ item:prize }">
								<v-btn color="secondary" depressed small @click="duplicatePrize(prize)">
									Duplicate Prize
								</v-btn>
							</template>
						</bw-table>

					</v-col>
				</v-row>
			</v-container>
		</ui-box>


		<v-row>
			<v-col>
				<v-btn
						class="mb-6 ms-2 mt-2 rounded-lg"
						color="info"
						depressed
						@click="showAddNewPrize = true"
				>
					<v-icon>
						mdi-plus
					</v-icon>
					Add New Prize
				</v-btn>
			</v-col>
		</v-row>


		<v-dialog
				v-model="showAddNewPrize"
				content-class="rounded-xl"
				persistent
				scrollable
				width="1000px"
		>
			<v-card class="position-relative" rounded="xl" height="100%">
				<v-form v-model="formAddNewPrizeIsValid"
								ref="formNewPrize">

					<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
						<h6>New Prize</h6>
						<v-btn
								class="mt-n1 me-n2"
								color="black"
								depressed
								icon
								@click="hideAndCleanNewPrize"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>

					<v-card-text>
						<!-- Image -->
						<v-row>
							<v-col>
								<span class="grey--text text--darken-1 text-body-2">Prize Image</span>
							</v-col>
						</v-row>
						<v-row>
							<bw-image
									v-model="newPrize.media[0]"
									class="rounded-lg"
									:upload-assignment="'product'"
									:upload-assignment-id="newPrize.id"
									:key="prizesMediaKey"
							></bw-image>
							<span class="red--text">*</span>
						</v-row>
						<!-- End: Image -->

						<!-- Name -->
						<v-row>
							<v-col>
								<v-text-field
										v-model="newPrize.name"
										class="rounded-lg required"
										label="Prize Name"
										outlined
										persistent-hint
										type="text"
										:rules="rules.name"
								></v-text-field>
							</v-col>
						</v-row>
						<!-- End: Name -->

						<!-- Highlights -->
						<v-row>
							<v-col>
								<v-textarea
										v-model="newPrize.highlights"
										auto-grow
										class="rounded-lg required"
										counter="250"
										hint="Add one description per line"
										label="Prize Description"
										outlined
										persistent-hint
										rows="4"
										:rules="rules.highlights"
								></v-textarea>
							</v-col>
						</v-row>
						<!-- End: Highlights -->

						<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

						<!-- Attributes -->
						<ui-box>
							<h5>Attributes</h5>

							<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

							<!-- Add Attribute -->
							<v-row>
								<v-col>
									<v-btn
											class="mb-6 ms-2 mt-2 rounded-lg"
											color="info"
											depressed
											@click="showAddAttributeForm = true"
									>
										<v-icon>
											mdi-plus
										</v-icon>
										Add Attribute
									</v-btn>
								</v-col>
							</v-row>


							<template v-if="showAddAttributeForm">
								<v-form v-model="formAddAttributeIsValid"
												ref="formAttributes">
									<ui-box>
										<v-row>
											<v-col>
												<v-select
														v-model="partnerAttributeSelect"
														class="rounded-lg"
														:items="extraData.partnerAttributes"
														item-text="name"
														item-value="id"
														label="Current attributes"
														outlined
												></v-select>
											</v-col>
										</v-row>

										<v-row>
											<v-col>
												<v-text-field
														v-model="newAttribute.name"
														class="rounded-lg required"
														label="Name"
														outlined
														persistent-hint
														type="text"
														@keydown="newAttribute.attribute_id = null"
														:rules="rules.attribute_name"
												></v-text-field>
											</v-col>
										</v-row>
										<v-row>
											<v-col>
												<v-btn
														class="me-2 me-md-4 rounded-lg"
														color="grey darken-1"
														depressed
														text
														@click="hideAndCleanAttributes"
												>
													Cancel
												</v-btn>
												<v-btn
														class="rounded-lg"
														color="primary"
														depressed
														:disabled="!formAddAttributeIsValid"
														@click="saveAttribute"
												>
													Add
												</v-btn>
											</v-col>
										</v-row>

									</ui-box>
								</v-form>
							</template>

							<!-- End: Add Attribute -->

							<!-- Attributes List -->
							<template v-if="newPrize.attributes.length > 0"
												v-for="(attr, index) in newPrize.attributes">
								<v-row>
									<v-col cols="9">
										<v-text-field
												v-model="attr.name"
												class="rounded-lg"
												label="Name"
												outlined
												readonly
												persistent-hint
												type="text"
										></v-text-field>
									</v-col>
									<v-col cols="3">
										<v-btn color="bw-warning"
													 class="mb-6 ms-2 mt-2 rounded-lg"
													 depressed
													 @click="removeAttribute(index)"
										>
											<v-icon>mdi-trash-can-outline</v-icon>
											Remove
										</v-btn>
									</v-col>
								</v-row>

								<v-divider v-if="newPrize.attributes.length > 1"
													 class="mb-6 mt-4 opacity-80"></v-divider>
							</template>

							<!-- End: Attributes List -->

						</ui-box>
						<!-- End: Attributes-->

						<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

						<!-- Delivery Method -->
						<ui-box>
							<h5>Delivery Method</h5>

							<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

							<v-row>
								<v-col>
									<v-select
											v-model="deliveryMethod"
											class="rounded-lg required"
											:items="[{name: 'Shipped', value: 'shipped'}, {name: 'Picked Up', value: 'picked_up'}, {name: 'Shipped or Picked Up', value: 'shipped_or_picked_up'}]"
											item-text="name"
											label="Delivery Method"
											outlined
											:rules="rules.delivery_method"
									></v-select>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-textarea
											v-if="deliveryMethod === 'shipped' || deliveryMethod === 'shipped_or_picked_up'"
											v-model="newPrize.shipping_details"
											auto-grow
											class="rounded-lg"
											counter="250"
											label="Shipping Details"
											outlined
											persistent-hint
											rows="4"
									></v-textarea>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-textarea
											v-if="deliveryMethod === 'picked_up' || deliveryMethod === 'shipped_or_picked_up'"
											v-model="newPrize.pickup_instructions"
											auto-grow
											class="rounded-lg"
											counter="250"
											label="Pickup Instructions"
											outlined
											persistent-hint
											rows="4"
									></v-textarea>
								</v-col>
							</v-row>
						</ui-box>
						<!-- End: Delivery Method -->
					</v-card-text>

					<v-card-actions class="px-4 px-md-8">
						<v-spacer></v-spacer>
						<v-flex shrink>
							<v-btn
									class="me-2 me-md-4 rounded-lg"
									color="grey darken-1"
									depressed
									outlined
									@click="hideAndCleanNewPrize"
							>
								Cancel
							</v-btn>
							<v-btn
									class="rounded-lg"
									color="primary"
									depressed
									:disabled="!validAddPrizeForm"
									@click="saveNewPrize"
							>
								Save Prize
							</v-btn>
						</v-flex>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import { helpers } from '../../../../../helpers';
import { passHelpers } from '../../helpers';

export default {
	name: "PrizeCreation",
	props: {
		newPass: {
			type: Object,
			required: true,
		},
		partner: {
			type: Object | null,
			default: null
		},
		extraData: {
			type: Object,
			default: () => ({})
		},
		showSections: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			prizesHeaders: [
				{
					align: 'start',
					mandatory: true,
					text: 'Prize',
					value: 'name',
					width: '90%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '10%'
				}
			],
			rules: {
				name: [v => !!v || 'Name is required.'],
				highlights: [v => !!v || 'Prize description is required.'],
				attribute_name: [
					v => !!v || 'Attribute name is required.', v => {
						const foundInPartnerAttributes = this.extraData.partnerAttributes.find(attribute => attribute.name === v);
						const foundInNewAttributes = this.newPrize.attributes.find(attribute => attribute.name === v);
						return ((foundInPartnerAttributes && v !== this.selectedPartnerAttributeName) || foundInNewAttributes)
								? 'Attribute name already exists.'
								: true;
					}
				],
				delivery_method: [v => !!v || 'Delivery method is required.'],
			},
			allPrizes: [],
			prizesTableKey: 0,
			prizesMediaKey: 0,
			showAddNewPrize: false,
			formAddNewPrizeIsValid: false,
			showAddAttributeForm: false,
			formAddAttributeIsValid: false,
			newPrize: new Prize(this.newPass, this.extraData),
			newAttribute: new Attribute(),
			selectedPartnerAttributeName: null,
		}
	},
	mounted() {
		this.refreshAllPrizes();
	},
	computed: {
		displayAllPrizes() {
			return this.allPrizes;
		},
		validAddPrizeForm() {
			const validImage = this.newPrize.media.length > 0;
			return validImage && this.formAddNewPrizeIsValid;
		},
		partnerAttributeSelect: {
			get() {
			},
			set(value) {
				const attribute = this.extraData.partnerAttributes.find(attribute => attribute.id === value);
				if(attribute) {
					this.newAttribute.attribute_id = attribute.id;
					this.newAttribute.name = attribute.name;
					this.selectedPartnerAttributeName = attribute.name;
				}
			}
		},
		deliveryMethod: {
			get() {
				if(this.newPrize.shipped && this.newPrize.picked_up)
					return 'shipped_or_picked_up';
				else if(this.newPrize.shipped)
					return 'shipped';
				else if(this.newPrize.picked_up)
					return 'picked_up';
				else
					return '';
			},
			set(value) {
				switch (value) {
					case 'shipped_or_picked_up':
						this.newPrize.shipped = 1;
						this.newPrize.picked_up = 1;
						this.newPrize.redemption_validation = 'pin';
						break;
					case 'shipped':
						this.newPrize.shipped = 1;
						this.newPrize.picked_up = 0;
						this.newPrize.redemption_validation = '';
						break;
					case 'picked_up':
						this.newPrize.shipped = 0;
						this.newPrize.picked_up = 1;
						this.newPrize.redemption_validation = 'pin';
						break;
					default:
						this.newPrize.shipped = 0;
						this.newPrize.picked_up = 0;
						this.newPrize.redemption_validation = '';
				}
			}
		},
	},
	methods: {
		shouldShowSection(section) {
			return !this.showSections.length || this.showSections.includes(section);
		},
		saveAttribute() {
			this.newPrize.attributes.push(this.newAttribute);
			this.hideAndCleanAttributes();
		},
		removeAttribute(index) {
			this.newPrize.attributes.splice(index, 1);
		},
		hideAndCleanAttributes() {
			this.showAddAttributeForm = false;
			this.newAttribute = new Attribute();
		},
		duplicatePrize(prize) {
			this.showAddNewPrize = true;
			this.newPrize = new Prize(this.newPass, this.extraData);
			this.newPrize.name = '(Duplicated Of) ' + prize.name;
			this.newPrize.media = prize.media || [];
			this.prizesMediaKey += 1;
			this.newPrize.highlights = prize.highlights;
			this.newPrize.attributes = prize.attributes || [];
			this.newPrize.shipped = prize.shipped || 1;
			this.newPrize.picked_up = prize.picked_up || 0;
			this.newPrize.shipping_details = prize.shipping_details;
			this.newPrize.pickup_instructions = prize.pickup_instructions
		},
		hideAndCleanNewPrize() {
			this.showAddNewPrize = false;
			this.newPrize = new Prize(this.newPass, this.extraData);
			this.$refs.formNewPrize.reset();
			this.prizesMediaKey += 1;
		},
		refreshAllPrizes() {
			axios.get(`/partner-portal/${this.partner.id}/passes/prizes`)
					.then(response => {
						this.allPrizes = response.data.allPrizes;
						this.prizesTableKey += 1;
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					});
		},
		saveNewPrize() {
			this.$refs.formNewPrize.validate();
			if(!this.formAddNewPrizeIsValid) return;

			const url = `/partner-portal/${this.partner.id}/passes/save-prize/${this.newPrize.id || ''}`;
			axios.put(url, this.newPrize)
					.then(response => {
						window.EventBus.$emit('system-messages', [
							{
								message: 'Prize created. Retrieving prizes list...',
								messageType: 'success',
								showOverlay: true
							}
						]);
						this.hideAndCleanNewPrize();
						this.refreshAllPrizes();
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					});

		}
	}
}

function Prize(newPass, extraData) {
	this.template_id = extraData.prizeTemplate.id;
	this.name = null;
	this.media = [];
	this.categories = [extraData.prizeCategory.id];
	this.status = extraData.prizeStatus.id;
	this.highlights = null;
	this.attributes = [];
	this.redeem_on_dashboard = 1;
	this.redemptions = 'shipped';
	this.shipped = 1;
	this.picked_up = 0;
	this.shipping_details = null;
	this.pickup_instructions = null;
	this.redemption_validation = '';
}

function Attribute() {
	this.attribute_id = null;
	this.name = null;
}

</script>